import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Modal, Table } from 'antd';
const DocRevised = ({ open, onClose, data, lstCmts }) => {
    var _a, _b;
    const columns = [
        {
            title: 'Version',
            dataIndex: 'intVersion',
            key: '1',
            render: (text, record, index) => _jsxs(_Fragment, { children: ["V", text] })
        },
        {
            title: 'Document Name',
            dataIndex: 'strDocName',
            key: '2'
        },
        {
            title: 'Uploaded By',
            dataIndex: 'strUploadedBy',
            key: '3'
        },
        {
            title: 'Uploaded Date',
            dataIndex: 'dtUploadedDate',
            key: '4'
        }
    ];
    return (_jsx(Modal, { title: _jsxs(_Fragment, { children: [(data === null || data === void 0 ? void 0 : data.key) + 1, " - ", (_a = data === null || data === void 0 ? void 0 : data.objLuDocumentCategory) === null || _a === void 0 ? void 0 : _a.strLongDesc, " -", ' ', (_b = data === null || data === void 0 ? void 0 : data.objDocumentType) === null || _b === void 0 ? void 0 : _b.strLongDesc, " -", ' ', (data === null || data === void 0 ? void 0 : data.boolRevisedVersion) ? 'View Revised Version' : 'View Previous Version'] }), width: 1000, open: open, onCancel: onClose, footer: null, children: _jsx(Table, { columns: columns, dataSource: lstCmts.map((item, index) => (Object.assign(Object.assign({}, item), { key: index }))) }) }));
};
export default DocRevised;
